import requestUtils from 'api/requestUtils'
import { BusinessResponses } from '@luxuryescapes/contract-business'

export enum EmailOrDomainExistsErrorCode {
  EMAIL_ALREADY_EXISTS = 'EMAIL_ALREADY_EXISTS',
  DOMAIN_ALREADY_EXISTS = 'DOMAIN_ALREADY_EXISTS',
}

async function requestCheckEmailAndDomainAssociation(email: string) {
  return await requestUtils.get<BusinessResponses.BaseResponse<null>>(`/api/business-traveller/businesses/email-or-domain-exists?email=${encodeURIComponent(email)}`)
}

export default requestCheckEmailAndDomainAssociation
